module.exports = __webpack_public_path__ + "img/lanternes-volantes_photos_v2_x2.38546f3.png";